"use client";

import Image from "next/legacy/image";
import { motion } from "framer-motion";

export default function  KeyOfferings() {
  const sectionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  const offerings = [
    {
      title: "Robotics And Intelligence",
      image: "/RoboticsPreview.jpeg",
      description:
        "Design autonomous systems for manufacturing and retail, enhancing efficiency with seamless human-robot collaboration.",
      link: "../robotics"
    },
    {
      title: "Connected IoT Ecosystems",
      image: "/iot.png",
      description:
        "Build interconnected IoT ecosystems with secure device communication, real-time data exchange, and scalable infrastructure.",
      link: "../connected-iot-ecosystems"
    },
    {
      title: "Intelligent Business Platforms",
      image: "/employee-working.jpg",
      description:
        "Leverage AI-driven platforms to streamline business operations, improve decision-making, and drive growth with actionable insights.",
      link: "../intelligent-business"
    },
    {
      title: "AI-Driven Innovation",
      image: "/robotics.png",
      description:
        "Optimize workflows with AI and machine learning, delivering innovative solutions tailored to industry challenges.",
      link: "../ai-driven-innovation"
    },
    {
      title: "Immersive Digital Experiences",
      image: "/vr.png",
      description:
        "Create immersive VR and AR experiences that engage users, offering interactive and realistic digital environments.",
      link: "../immersive-digital-experiences"
    },
    {
      title: "Advanced Data Solutions",
      image: "/human.png",
      description:
        "Unlock the power of data with advanced analytics, providing actionable insights for smarter decision-making and strategy.",
      link: "../adavance-data-solutions"
    },
  ];

  return (
    <motion.section
      className="bg-gradient-to-r from-[#00063A] via-[#425fae] to-[#00063A] py-8 px-8 relative"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={sectionVariants}
    >
      <div className="absolute z-5 inset-0">
        <Image
          src="/Group.png"
          alt="Background pattern"
          layout="fill"
          className="object-stretch opacity-50"
          quality={100}
        />
      </div>

      <div className="relative z-10">
        <h2 className="text-3xl font-bold text-center text-white">
          Our Key Offerings
        </h2>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {offerings.map((offering, index) => (
            <div key={index} className="rounded-lg overflow-hidden group perspective-1000">
              {/* Flipping Container */}
              <div className="relative w-full h-64 transition-transform duration-700 transform group-hover:rotate-y-180 transform-style-3d">
                {/* Front Face */}
                <div className="absolute inset-0 backface-hidden">
                  <div className="absolute inset-0">
                    <Image
                      src={offering.image}
                      alt={offering.title}
                      layout="fill"
                      objectFit="cover"
                      className="rounded-t-lg"
                    />
                  </div>
                  <div className="absolute bottom-0 w-full p-4 bg-black bg-opacity-50 rounded-b-lg">
                    <h3 className="text-xl font-semibold text-white">{offering.title}</h3>
                  </div>
                </div>
                {/* Back Face */}
                <div className="absolute inset-0 backface-hidden rotate-y-180 bg-blue-900 rounded-lg">
                  <div className="p-8 flex flex-col justify-center items-center h-full text-center">
                    <h3 className="text-xl font-bold text-blue-500 mb-2">{offering.title}</h3>
                    <p className="text-gray-300">{offering.description}</p>
                    {/*Explore Button */}
                    <a href={offering.link}>
                      <button className="relative transform mt-2 text-white uppercase border border-white rounded-full hover:bg-white hover:text-[#00063A] transition">Explore</button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </motion.section>
  );
}